export const name = "myfiles";
export const origin = "mediafire.com";
export const version = "5.9.19";
